import React from 'react';
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';
import { useSelector } from 'react-redux';

function CourseReminderModal(props) {
  const setHidden = () => {
    // localStorage.setItem('notificationPopUp', new Date().getTime());
    props.onHide();
  };
  const modalStyle = {
    backgroundColor: props.backgroundColor,
    color: props.textColor,
  };

  const buttonStyle = {
    backgroundColor: props.textColor,
    color: props.backgroundColor,
    borderColor: props.textColor,
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="bg-transparent course-reminder-modal"
    >
      {props.popUpImage ? (
        <div className="course-reminder-content ads-content-image p-0" style={modalStyle}>
          <button type="button" class="close" data-dismiss="modal" onClick={setHidden}>&times;</button>
        <Modal.Body>
          <div className="popup-image-container">
            <a class="popup bigyapan-content" href={props.link}>
              <img src={props.popUpImage} alt="Popup Image" />
            </a>
          </div>
        </Modal.Body>
        </div>
      ) : (
        <>
        <div className="course-reminder-content ads-content-text" style={modalStyle}>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: props.popUpMessage }} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" className="px-4" onClick={setHidden} style={buttonStyle}>
              OK
            </Button>
          </Modal.Footer>
          </div>
        </>
      )}
    </Modal>
  );
}

export default CourseReminderModal;
